module.exports = __webpack_public_path__ + "img/icon-h.1da8d391.svg";